(function() {
  const container = document.getElementById("comments-app");

  if (!container) {
    return; // Exit immediately
  }

  const postKey = container.dataset.postKey;

  // Decide which worker to use based on the current URL
  const isDev = window.location.hostname.includes('pages.dev') || window.location.hostname === 'localhost';
  const workerUrl = isDev
    ? "https://raredoramas-comments-worker-dev.varmail00001.workers.dev"
    : "https://raredoramas-comments-worker.varmail00001.workers.dev";

  const isLatest = postKey === 'latest';
  const loadBtn = document.getElementById("load-comments");
  const commentsList = document.getElementById("comments-list");
  const countEl = document.getElementById("comment-count");
  const pagination = document.getElementById("pagination-controls");
  const commentForm = document.getElementById("comment-form");

  if (isLatest) {
    if (commentForm) commentForm.style.display = 'none';
    if (countEl) countEl.parentElement.style.display = 'none';
  }

  let currentPage = 1;

  async function fetchCount() {
    if (isLatest) return; // Skip count for latest
    try {
      const res = await fetch(`${workerUrl}?post=${postKey}&countOnly=true`);
      const data = await res.json();
      countEl.innerText = data.total;

      if (data.total === 0) {
        loadBtn.style.display = "none";
      }
    } catch (error) {
      console.error('Failed to fetch count:', error);
    }
  }

  function createCommentHtml(c) {
    const isAdmin = c.author_id === 1;
    const dateStr = new Date(c.created_at).toLocaleDateString('en-GB', {
      year: 'numeric', month: 'short', day: 'numeric'
    });

    // For latest comments, show "on Post" link. Prefer the real title stored
    // at submit time; fall back to a reconstruction from the slug for older
    // rows saved before post_title was persisted.
    const postTitle = c.post_title || c.post_key
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
    const onPostHtml = isLatest && c.post_key
      ? `<span class="comment__on"> on <a href="/page/${c.post_key}/">${postTitle}</a> post</span>`
      : '';

    return `
      <div class="comment${isAdmin ? ' admin' : ''}" id="comment-${c.id}" data-id="${c.id}">
        <div class="comment__header">
          <strong class="comment__author with-icon"><span class="icon"></span>${escapeHtml(c.author || 'Anonymous')}${onPostHtml}</strong>
          <time datetime="${c.created_at}" class="comment__date date with-icon"><span class="icon"></span>${dateStr}</time>
        </div>
        <div class="comment__content">${escapeHtml(c.content)}</div>
      </div>
    `;
  }

  async function fetchComments(page = 1, parentId = 0) {
    try {
      if (parentId === 0) {
        commentsList.classList.add('loading');
        loadBtn.disabled = true;
      }

      // If isLatest, purely fetch ?post=latest (no page/parentId params needed usually, but we keep structure)
      const query = isLatest
        ? `${workerUrl}?post=latest`
        : `${workerUrl}?post=${postKey}&page=${page}&parentId=${parentId}`;

      const res = await fetch(query);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();

      if (!data.comments || !Array.isArray(data.comments)) {
        throw new Error('Invalid response format');
      }

      if (parentId === 0) {
        if (!isLatest) countEl.innerText = data.total;

        commentsList.innerHTML = data.comments.map(c => createCommentHtml(c)).join("");

        if (!isLatest) {
          currentPage = data.page;
          document.getElementById("page-info").innerText = `${data.page} of ${data.totalPages}`;
          document.getElementById("prev-page").disabled = currentPage <= 1;
          document.getElementById("next-page").disabled = currentPage >= data.totalPages;
          pagination.style.display = data.totalPages > 1 ? "flex" : "none";
        } else {
          pagination.style.display = "none";
        }

        loadBtn.style.display = "none";
        commentsList.classList.remove('loading');
      } else {
        // ... (reply handling - not used for latest)
      }

    } catch (error) {
      console.error('Failed to fetch comments:', error);
      if (parentId === 0) {
        commentsList.innerHTML = '<p class="error">Failed to load comments. Please try again later.</p>';
        commentsList.classList.remove('loading');
      }
    } finally {
      if (parentId === 0) loadBtn.disabled = false;
    }
  }

  async function submitComment(event) {
    event.preventDefault();

    const submitBtn = event.target.querySelector('button[type="submit"]');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Posting...';

    const formData = new FormData(event.target);
    const data = Object.fromEntries(formData.entries());

    const postTitle = container.dataset.postTitle;

    try {
      const response = await fetch(workerUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          post_key: postKey,
          post_title: postTitle,
          author: data.author,
          content: data.content,
          honeypot: data.website_url,
          turnstile_token: data['cf-turnstile-response']
        })
      });

      if (response.ok) {
        event.target.reset();
        if (window.turnstile) {
          turnstile.reset();
        }
        await fetchComments(1);
      } else {
        let errorMessage = 'Failed to submit comment';
        try {
          const errorData = await response.json();
          errorMessage = errorData.error || errorMessage;
        } catch (e) {
          // If response is not JSON, try text
          errorMessage = await response.text() || errorMessage;
        }

        if (window.turnstile) {
          window.turnstile.reset();
        }
        alert(`Error: ${errorMessage}`);
      }
    } catch (error) {
      console.error('Submit error:', error);
      alert("Error submitting comment. Please try again.");
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Post Comment';
    }
  }

  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // Load count on page load
  fetchCount();

  // Event listeners
  function scrollToComments() {
    const container = document.getElementById("comments-container");
    if (container) {
      const top = container.getBoundingClientRect().top + window.scrollY - 200;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }

  loadBtn.addEventListener('click', () => fetchComments(1));
  document.getElementById("prev-page").addEventListener('click', async () => {
    await fetchComments(currentPage - 1);
    scrollToComments();
  });
  document.getElementById("next-page").addEventListener('click', async () => {
    await fetchComments(currentPage + 1);
    scrollToComments();
  });
  document.getElementById("comment-form").addEventListener('submit', submitComment);
})();
